import React from 'react';
import { CheckCircle2Icon, TruckIcon } from 'lucide-react';
import type { Configuration } from '../../types/clock';
import { detailPrix, formatPrix, totalPrix } from '../../utils/price';
type Props = {
  config: Configuration;
  onValider: () => void;
  valide: boolean;
};
export function Recapitulatif({
  config,
  onValider,
  valide
}: Props) {
  const lignes = detailPrix(config);
  const total = totalPrix(config);
  return <section aria-labelledby="recap-titre" className="rounded-2xl border border-line bg-parchment p-6 shadow-card" data-id="element-46" data-mp="36pzsnzrevwc1">
      <h2 id="recap-titre" className="font-display text-lg text-ink" data-id="element-47" data-mp="31o23kowby7b6">
        Récapitulatif
      </h2>

      <dl className="mt-4 space-y-2.5 text-sm" data-id="element-48" data-mp="3ggufp6chezyj">
        {lignes.map(ligne => <div key={ligne.label} className="flex items-baseline justify-between gap-4" data-id="element-49" data-mp="3bmzzicw35347">
            <dt className="text-muted" data-id="element-50" data-mp="2nx5ntyni5klj">{ligne.label}</dt>
            <dd className="tabular-nums text-ink" data-id="element-51" data-mp="2j05i5oukejuy">{formatPrix(ligne.montant)}</dd>
          </div>)}
      </dl>

      <div className="mt-4 flex items-baseline justify-between border-t border-line pt-4" data-id="element-52" data-mp="bfid5bn5v1t">
        <span className="text-sm text-muted" data-id="element-53" data-mp="5as23h77um06">Total TTC</span>
        <span className="font-display text-2xl text-ink tabular-nums" data-id="element-54" data-mp="598oxzguwr2m">{formatPrix(total)}</span>
      </div>

      {valide ? <p className="mt-5 flex items-start gap-2.5 rounded-xl bg-forest/[0.08] px-4 py-3.5 text-sm text-forest-dark" data-id="element-55" data-mp="e4eucxc7t74m">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-56" data-mp="3dk1zpwyblupo" />
          <span data-id="element-57" data-mp="3ihbpxetjaaek">
            Votre horloge est dans le panier. Nous vous enverrons un bon à tirer par e-mail sous
            24 h avant lancement de l'impression.
          </span>
        </p> : <button type="button" onClick={onValider} className="mt-5 w-full rounded-full bg-terracotta px-6 py-3.5 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-terracotta-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta" data-id="element-58" data-mp="3rj1or5pqwbmd">
          Ajouter au panier
        </button>}

      <p className="mt-4 flex items-center gap-2 text-xs text-muted" data-id="element-59" data-mp="2ytc1kdjghiir">
        <TruckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-60" data-mp="3cuepkvu0h2wb" />
        Fabrication 3 jours ouvrés · Livraison offerte dès 60 €
      </p>
    </section>;
}